import { observer } from "mobx-react-lite"
import { FC, useContext, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { Context } from "../.."
import styles from "../../styles/Loyalty/LoyaltyStore.module.scss"
import XPageModal from "../../app/libs/topgun-ui-kit/xmodals/XPageModal"
import { Animator } from "../../app/libs/x-ui-animator/Animator"
import {XButton, XForm} from "../../app/libs/x-ui-core/components"
import {projectReview, getProjectReview} from "../../api/loyalty"
import {message} from "antd"

interface ProjectReviewProps {}

const ProjectReview: FC<ProjectReviewProps> = ({  }) => {

  const { store, loyaltyStore } = useContext(Context)

  const navigate = useNavigate()

  const sendReview = async () => {
    loyaltyStore.setIsReviewLoading(true)

    const res = await projectReview({
      text: loyaltyStore.prevText
    })

    loyaltyStore.setIsReviewLoading(false)

    if (res.state == 0) {
      return message.error(res.message)
    }

    loyaltyStore.setAlreadyReview(`${loyaltyStore.prevText}`)
    loyaltyStore.setPrevText("")
  }

  useEffect(() => {
    // Загружаем отзыв пользователя только при открытии модального окна и если его ещё не загружали
    if (loyaltyStore.projectReviewVisible && loyaltyStore.alreadyReview === "") {
      getProjectReview().then((rsx: any) => {
        if (rsx.state === 1) {
          loyaltyStore.setAlreadyReview(rsx.review.text)
        }
      })
    }
  }, [loyaltyStore.projectReviewVisible])

  return (
    <>
      <XPageModal
        id="release"
        visible={loyaltyStore.projectReviewVisible}
        onClose={() => {
          loyaltyStore.setProjectReviewVisible(false)
        }}
        // theme="dark"
        activeZone={false}
        title={<><b className="xmtitle">Отзыв о <strong>работе сервиса</strong></b></>}
        content={<>
          <div className={styles.objectively + " " + styles.release}>
            <p>Нам важно знать ваше мнение о работе сервиса <b>ПЛЮС</b>.
            <br />
            <br />
            Пожалуйста, опишите, что вам нравится, что не нравится и что необходимо доработать, чтобы 100%-й кешбэк стал доступен для всех.</p>
          
            {loyaltyStore.alreadyReview == "" ? <>
              <XForm theme="dark">
                <XForm.Field>
                  <XForm.Field.Label title="Отзыв" />
                  <XForm.Field.Textarea placeholder="Ваш отзыв" value={loyaltyStore.prevText} onChange={(ev) => loyaltyStore.setPrevText(ev.target.value)} />
                </XForm.Field>
              </XForm>

              <XButton disabled={loyaltyStore.isReviewLoading} onClick={() => sendReview()}>Отправить</XButton>
            </> : <>
              <XForm theme="dark">
                <XForm.Field locked>
                  <XForm.Field.Label title="Ваш отзыв" />
                  <XForm.Field.Textarea placeholder="Ваш отзыв" value={loyaltyStore.alreadyReview} onChange={(ev) => false} />
                </XForm.Field>
              </XForm>
            </>}
          </div>
        </>} />
    </>
  )
}

export default observer(ProjectReview)